import React, { useEffect, useState } from 'react'
import { motion } from 'framer-motion'
import { ArrowUpIcon } from '@heroicons/react/24/outline'

const BackToTopButton = () => {
  const [showTopButton, setShowTopButton] = useState(false)

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 0) {
        setShowTopButton(true)
      } else {
        setShowTopButton(false)
      }
    }

    window.addEventListener('scroll', handleScroll)
    return () => {
      window.removeEventListener('scroll', handleScroll)
    }
  }, [])

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' })
  }

  return (
     <motion.button
      className="p-3 fixed bottom-[170px] right-6 bg-primary text-white rounded-full shadow-md flex items-center justify-center"
      onClick={scrollToTop}
      initial={{ opacity: 0 }}
      animate={{ opacity: showTopButton ? 1 : 0 }}
      transition={{ duration: 0.5 }}
      style={{
        zIndex: 900,
        display: showTopButton ? 'block' : 'none',
      }}
    >
      <ArrowUpIcon className="w-8 h-8" />
    </motion.button>
  )
}

export default BackToTopButton
